// extracted by mini-css-extract-plugin
export default {"logsContainer":"LessonLogs_logsContainer__HXUYs"};